import { Dialog, useDialogProps } from "../../../../legacy-components/dialog/Dialog";
import React, { useEffect, useState } from "react";
import { Box, Button, Tooltip } from "@material-ui/core";
import ApiService from "../services/ApiService";
import { Alert } from "@material-ui/lab";
import { resolveAPIErrorMessage } from "modus/components/error-message/ErrorMessage";
import { VersionDialog } from "./VersionDialog";
import AddIcon from "@material-ui/icons/Add";
import { FormattedMessage } from "react-intl";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";




interface VersionCreatorProp {
  getVersions: () => void;
  apiId: string;
  isFlattenedApplication?: boolean;
}

const VERSION_CREATION_RESTRICTED_MESSAGE =
  "Version creation restricted for dev and qa APIs";


export const VersionCreator: React.FC<VersionCreatorProp> = React.memo(
  ({ getVersions, apiId, isFlattenedApplication = false }) => {
    const [version, setVersion] = useState("");
    const { open, toggle, setOpen } = useDialogProps();

  const { state, subscribe, reset } = useAsyncAction(() =>
    ApiService.createNewVersion(apiId, version),
  );

  // Reset async state when dialog opens so a previous success doesn't immediately close it on reopen
  useEffect(() => {
    if (open) {
      reset();
      setVersion("");
    }
    return () => {
      reset();
      setVersion("");
    };
  }, [open, reset]);

  useEffect(() => {
    if (!getVersions || !state.loaded || !setOpen) {
      return;
    }
    if(!state.error){
      setOpen(false);
      getVersions();
    }
    
    if(state.error) {
       if(!open){
        getVersions();
       }
    }
  }, [ state.loaded, state.error, getVersions, open, setOpen]);

  const addVersionButton = (
    <Button
      type="button"
      startIcon={<AddIcon />}
      variant="contained"
      color="primary"
      size="large"
      style={{ padding: "10px 21px", borderRadius: 0 }}
      onClick={toggle}
      disabled={isFlattenedApplication}
    >
      <FormattedMessage defaultMessage="Add New Version"></FormattedMessage>
    </Button>
  );

  return (
    <Box key={"version-creator"}>
      {isFlattenedApplication ? (
        <Tooltip title={VERSION_CREATION_RESTRICTED_MESSAGE} placement="top" arrow>
          <span style={{ display: "inline-flex" }}>{addVersionButton}</span>
        </Tooltip>
      ) : (
        addVersionButton
      )}
    
      <Dialog
        open={open}
        onClose={toggle}
        title=" Add New Version"
      >
        {state?.error && (
          <Alert severity="error">{resolveAPIErrorMessage(state.error)}</Alert>
        )}
        <VersionDialog
          version={version}
          setVersion={setVersion}
          onClose={toggle}
          handleSubmit={subscribe}
          isLoading={state.loading}
        />
      </Dialog>
    </Box>
  );
});

export default VersionCreator;
